import { useRuntimeEventListener } from './useRuntimeEventListener'
import {
  FormApplyRequestedEventType,
  type FormApplyRequestedDetail,
  type FormApplyRequestedEvent
} from '../events/formApplyEvents'

export type UseProposeFormValuesOptions = {
  /**
   * Only apply events for this form id.
   */
  formId: string
  /**
   * Called when the user clicks "Apply" in the tool renderer UI.
   */
  onApply: (detail: FormApplyRequestedDetail) => void
  /**
   * Disable listener (defaults to true).
   */
  enabled?: boolean
}

/**
 * Listen for form-apply requests emitted by tool renderers (e.g. `propose_form_values`)
 * and forward them to the host app so it can mutate local form state.
 */
export const useProposeFormValues = ({ formId, onApply, enabled = true }: UseProposeFormValuesOptions) => {
  useRuntimeEventListener<FormApplyRequestedEvent>(
    FormApplyRequestedEventType,
    (event) => {
      if (!enabled) return
      if (event.detail.formId !== formId) return
      onApply(event.detail)
    },
    [enabled, formId, onApply]
  )
}
